<script setup>
import {computed} from "vue";

defineProps({
  score: {
    type: Number,
    required: true,
    validate: (value) => value >= 0 && value <= 5
  }
});

// Done it this way so classes are compiled
const starClasses = computed(() => ({
  1: '[&>*:nth-child(-n+1)]:tw-text-primary',
  2: '[&>*:nth-child(-n+2)]:tw-text-primary',
  3:  '[&>*:nth-child(-n+3)]:tw-text-primary',
  4:  '[&>*:nth-child(-n+4)]:tw-text-primary',
  5:  '[&>*:nth-child(-n+5)]:tw-text-primary',
}));
</script>
<template>
  <svg
    :class="['tw-text-white', starClasses[score]]"
    width="120"
    height="24"
    viewBox="0 0 120 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.999 17.768L16.01 19.876C16.791 20.286 17.703 19.623 17.554 18.754L16.788 14.288L20.034 11.127C20.666 10.511 20.318 9.43798 19.444 9.31098L14.96 8.65898L12.955 4.59398C12.565 3.80298 11.436 3.80298 11.046 4.59398L9.03999 8.65898L4.55599 9.31098C3.68299 9.43798 3.33399 10.511 3.96599 11.127L7.21199 14.288L6.44599 18.754C6.29699 19.623 7.20899 20.287 7.98999 19.876L12.001 17.768H11.999Z"
      fill="currentColor"
      stroke="#2F52E0"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M35.999 17.768L40.01 19.876C40.791 20.286 41.703 19.623 41.554 18.754L40.788 14.288L44.034 11.127C44.666 10.511 44.318 9.43798 43.444 9.31098L38.96 8.65898L36.955 4.59398C36.565 3.80298 35.436 3.80298 35.046 4.59398L33.04 8.65898L28.556 9.31098C27.683 9.43798 27.334 10.511 27.966 11.127L31.212 14.288L30.446 18.754C30.297 19.623 31.209 20.287 31.99 19.876L36.001 17.768H35.999Z"
      fill="currentColor"
      stroke="#2F52E0"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M59.999 17.768L64.01 19.876C64.791 20.286 65.703 19.623 65.554 18.754L64.788 14.288L68.034 11.127C68.666 10.511 68.318 9.43798 67.444 9.31098L62.96 8.65898L60.955 4.59398C60.565 3.80298 59.436 3.80298 59.046 4.59398L57.04 8.65898L52.556 9.31098C51.683 9.43798 51.334 10.511 51.966 11.127L55.212 14.288L54.446 18.754C54.297 19.623 55.209 20.287 55.99 19.876L60.001 17.768H59.999Z"
      fill="currentColor"
      stroke="#2F52E0"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M83.999 17.768L88.01 19.876C88.791 20.286 89.703 19.623 89.554 18.754L88.788 14.288L92.034 11.127C92.666 10.511 92.318 9.43798 91.444 9.31098L86.96 8.65898L84.955 4.59398C84.565 3.80298 83.436 3.80298 83.046 4.59398L81.04 8.65898L76.556 9.31098C75.683 9.43798 75.334 10.511 75.966 11.127L79.212 14.288L78.446 18.754C78.297 19.623 79.209 20.287 79.99 19.876L84.001 17.768H83.999Z"
      fill="currentColor"
      stroke="#2F52E0"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M107.999 17.768L112.01 19.876C112.791 20.286 113.703 19.623 113.554 18.754L112.788 14.288L116.034 11.127C116.666 10.511 116.318 9.43798 115.444 9.31098L110.96 8.65898L108.955 4.59398C108.565 3.80298 107.436 3.80298 107.046 4.59398L105.04 8.65898L100.556 9.31098C99.683 9.43798 99.334 10.511 99.966 11.127L103.212 14.288L102.446 18.754C102.297 19.623 103.209 20.287 103.99 19.876L108.001 17.768H107.999Z"
      fill="currentColor"
      stroke="#2F52E0"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
